export const tableStyle = {
   width: '100%',
   fontSize: '12px'
};